import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

import { WizardService } from '../../../../services/wizard/wizard.service';
import { IWizardContact } from '../../../../models';

import { ITaskMeetingContact, ActiveStatuses } from 'common-lib';

@Component({
    selector: 'wizard-change-attendees-confirmation',
    templateUrl: './change-attendees-confirmation.component.html',
    styleUrls: [
        './change-attendees-confirmation.component.scss',
        '../confirmation.component.scss',
        '../../../form-styles.scss'
    ]
})
export class ChangeAttendeesConfirmationComponent implements OnInit {
    @Input() availabilityTypeText = '';
    @Input() availabilityUsers: IWizardContact[] = [];
    @Input() originalContacts: ITaskMeetingContact[] = [];
    @Input() selectedContacts: IWizardContact[] = [];
    @Input() vipContacts: IWizardContact[];
    @Input() currentUser: any;
    @Input() isUpdatingMeeting = false;
    @Input() taskStatus = '';
    public newContacts: IWizardContact[] = [];
    public existingContacts: IWizardContact[] = [];
    public isActiveTask = true;
    public meetingTime?: { start: string; end: string };
    public hasRemovedContacts = false;

    constructor(public wizardService: WizardService) {}

    ngOnInit() {
        this.meetingTime = this.wizardService.options.meetingTime;
        this.isActiveTask = ActiveStatuses.includes(this.taskStatus);
        const originalIds = this.originalContacts.map((contact) => contact.contactId) || [];
        const selectedIds = this.selectedContacts.map((contact) => contact.id) || [];

        this.hasRemovedContacts = _.some(originalIds, (id) => {
            return !selectedIds.includes(id);
        });
        this.newContacts = this.getNewContacts(originalIds, selectedIds, this.selectedContacts);
        this.existingContacts = this.getExistingContacts(originalIds, selectedIds, this.selectedContacts);
    }

    private getNewContacts(originalIds: string[], selectedIds: string[], selectedContacts: IWizardContact[]) {
        const newContactIds = _.difference(selectedIds, originalIds);
        return selectedContacts.filter((contact) => newContactIds.includes(contact.id));
    }

    private getExistingContacts(originalIds: string[], selectedIds: string[], selectedContacts: IWizardContact[]) {
        const existingContactIds = _.intersection(selectedIds, originalIds);
        return selectedContacts.filter((contact) => existingContactIds.includes(contact.id));
    }
}
